import revealOnScroll from "../utils/revealOnScroll"

class ServicesGrid {
	constructor(selector = ".service-card") {
		this.cards = Array.from(document.querySelectorAll(selector))

		this.init()
	}

	init() {
		if (!this.cards.length) {
			return
		}

		revealOnScroll(this.cards, {
			stagger: 120,
			visibleClass: "is-visible",
			observerOptions: { threshold: 0.15 }
		})
	}
}

export default ServicesGrid
